module.exports = __webpack_public_path__ + "static/media/thumbnail.fe49e6e2.jpg";